import { Component, Input, OnInit } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ITask, ITasksAttachment } from 'app/interfaces/task.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ToggleEvent } from 'shared/components/accordion/accordion.component';

@Component({
	selector: 'appointment-details-tasks',
	templateUrl: './appointment-details-tasks.component.html',
	styleUrls: ['./appointment-details-tasks.component.scss'],
})
export class AppointmentDetailsTasksComponent implements OnInit {
	@Input()
	public task: ITask | null = null;

	description = '';
	links: ITasksAttachment[] = [];

	constructor(public actionTrackerService: ActionTrackerService) {}

	public ngOnInit(): void {
		this.description = this.task?.description ?? '';
		this.links = this.task?.attachments ?? [];

		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Sidebar,
			ITEM_TYPE.Task,
			INTERACTION_TYPE.View,
			{}
		);
	}

	public preventAccordionToggle(event: Event): void {
		event.stopPropagation();
	}

	public onToggleAccordion(toggleEvent: ToggleEvent): void {
		const toggleStatus = toggleEvent.isOpen ? 'open' : 'close';
		this.trackToggleEvent(toggleStatus);
	}

	private trackToggleEvent(toggleStatus: 'open' | 'close'): void {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Sidebar,
			ITEM_TYPE.Task,
			INTERACTION_TYPE.Click,
			{
				toggle: toggleStatus,
			}
		);
	}
}
